module.exports = {
	'a': ['á','Á','à','À','ã','Ã','â','Â','ä','Ä','å','Å','ā','Ā'],
	'e': ['é','É','è','È','ê','Ê','ë','Ë','ē','Ē','ė','Ė','ę','Ę'],
	'i': ['î','Î','í','Í','ì','Ì','ï','Ï','ī','Ī','į','Į'],
	'o': ['ô','Ô','ò','Ò','ø','Ø','ō','Ō','ó','Ó','õ','Õ','ö','Ö'],
	'u': ['û','Û','ú','Ú','ù','Ù','ü','Ü','ū','Ū'],
	'c': ['ç','Ç','č','Č'],
	's': ['ś','Ś','š','Š'],
};



//////////////////
// WEBPACK FOOTER
// ./~/normalizer/charmaps.js
// module id = 18
// module chunks = 49 53 61 86 92 101 111 115